import { X509_CERTIFICATE_KEY_IDENTIFIER_TITLE } from '../constants';
export default {
    name: 'X509CertificateDetails',
    props: {
        subject: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subjectKeyIdentifier: {
            type: String,
            required: true
        }
    },
    computed: {
        subjectValues () {
            return this.subject.split(',');
        },
        subjectKeyIdentifierToDisplay () {
            return this.subjectKeyIdentifier.replaceAll(':', ' ');
        }
    },
    i18n: {
        keyIdentifierTitle: X509_CERTIFICATE_KEY_IDENTIFIER_TITLE
    }
};
